import React, { useEffect, useRef, useState } from "react";
import { Search, X } from "lucide-react";
import { api } from "../lib/api";
import { Input } from "./ui/input";

// Searchable customer picker (by name / phone / number). Fetches on the fly.
export function CustomerSearchSelect({ groupId, selected, onSelect, onClear, placeholder = "Cari nama / No. telepon...", testid = "customer-search-select" }) {
  const [q, setQ] = useState("");
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const boxRef = useRef(null);

  useEffect(() => {
    const h = (e) => { if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  useEffect(() => {
    setQ("");
    setItems([]);
    setOpen(false);
  }, [groupId]);

  useEffect(() => {
    if (selected) return;
    const t = setTimeout(() => {
      api.get("/customers", { params: { active: "active", group_id: groupId || undefined, q: q || undefined } })
        .then((r) => setItems((r.data || []).slice(0, 50))).catch(() => {});
    }, 300);
    return () => clearTimeout(t);
  }, [q, groupId, selected]);

  if (selected) {
    return (
      <div className="flex items-center gap-2 bg-white border border-taupe/30 rounded-md px-3 py-2 h-10" data-testid={`${testid}-selected`}>
        <span className="font-medium text-cocoa truncate">{selected.name}</span>
        {selected.phone && <span className="text-sm text-wmuted truncate">· {selected.phone}</span>}
        <button type="button" onClick={onClear} className="ml-auto shrink-0" data-testid={`${testid}-clear`}><X className="w-4 h-4 text-status-reject" /></button>
      </div>
    );
  }

  return (
    <div className="relative" ref={boxRef}>
      <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-wmuted" />
      <Input value={q} onChange={(e) => { setQ(e.target.value); setOpen(true); }} onFocus={() => setOpen(true)} placeholder={placeholder} className="pl-9 bg-white" data-testid={testid} />
      {open && (
        <div className="absolute z-30 mt-1 w-full bg-white border border-taupe/30 rounded-md shadow-lg max-h-64 overflow-y-auto">
          {items.length === 0 && <div className="px-3 py-2 text-sm text-wmuted">Tidak ada customer{groupId ? " di group ini" : ""}.</div>}
          {items.map((c) => (
            <button type="button" key={c.id} onClick={() => { onSelect(c); setOpen(false); setQ(""); }} data-testid={`${testid}-opt-${c.id}`} className="block w-full text-left px-3 py-2 hover:bg-ivory text-sm border-b border-taupe/10 last:border-0">
              <span className="font-medium text-cocoa">{c.name}</span>
              {c.phone ? <span className="text-wmuted"> · {c.phone}</span> : null}
              {c.number ? <span className="text-wmuted text-xs"> · {c.number}</span> : null}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
